import { memo, useCallback } from "react";
import { SimpleSelect, SimpleSelectProps } from "../../SimpleSelect";
import { UNITS } from "../constants";
import { formatValue } from "../converter";
import { LeadingZero, Locale } from "../types";
import { useCronFieldProps } from "./utils";

export type MonthDaysProps = Omit<SimpleSelectProps<number>, "onChange" | "options"> & {
  locale: Locale
  onChange?: ((newValue: number[]) => void) | undefined
  weekDays?: number[] | null
  leadingZero: LeadingZero
};

export const MonthDays = memo((
  {
    locale,
    weekDays,
    leadingZero,
    ...props
  }: MonthDaysProps) => {
  const value = props.value as number[];
  const noWeekDays = !weekDays || weekDays.length === 0;
  const displayMonthDays =
    (value && value.length > 0) ||
    ((!value || value.length === 0) && (!weekDays || weekDays.length === 0));
  const unit = UNITS.find(x => x.type === "month-days")!;
  const { options, onChange, isMulti } = useCronFieldProps(
    props.value,
    props.onChange,
    props.isMulti ?? false,
    unit,
  );

  const setOptionLabel = useCallback((v: number) => formatValue(v, unit, undefined, leadingZero),
    [ leadingZero, unit ]);

  return displayMonthDays ? (
    <div>
      {locale.prefixMonthDays !== "" && (
        <span>
          {locale.prefixMonthDays}
        </span>
      )}

      <SimpleSelect
        placeholder={noWeekDays ? locale.emptyMonthDays : locale.emptyMonthDaysShort}
        isClearable
        isSearchable
        {...props}
        isMulti={isMulti}
        onChange={onChange}
        options={options}
        setOptionLabel={setOptionLabel}
      />
    </div>
  ) : null;
});
